import { useAuthWrapper } from '@weareopenr/authkit';
import { Permissions } from '@weareopenr/configs';

export const usePermissions = () => {
  const { hasAnyPermission, hasPermission } = useAuthWrapper<Permissions>();

  const canAccessAdmin = hasAnyPermission([
    Permissions.BRANDS_CREATE,
    Permissions.BRANDS_DELETE,
    Permissions.BRANDS_UPDATE,
    Permissions.USERS_READ,
    Permissions.ROLES_READ,
  ]);

  // Gates "Create Timetable" and "Duplicate".
  const canCreateTimetables = hasPermission(Permissions.TIMETABLES_CREATE);
  // Gates editing an existing timetable's schedule (the + icons on the Timetable page).
  const canUpdateTimetables = hasPermission(Permissions.TIMETABLES_UPDATE);

  return { canAccessAdmin, canCreateTimetables, canUpdateTimetables };
};
